let animationsZone0 = {
    init: () => {
        // vars
        let theSun = ".theSun",
            theCloud = ".theCloud",
            theRGB = ".rgb",
            config = {
                rotate: {
                    rotation: '-360',
                    ease: Linear.easeNone,
                    repeat: -1,
                    transformOrigin: '50% 50%'
                }
            };

        // rotate the sun
        function rotateSun() {
            TweenMax.to(theSun, 5, {
                rotation: 360,
                transformOrigin: "center",
                ease: SlowMo.ease.config(0.5, 0.5, false),
                repeat: -1
            });
        }

        // move the cloud
        function moveCloud() {
            TweenMax.to(theCloud, 2, {
                x: 5,
                scale: 0.9,
                yoyo: true,
                repeat: -1
            });
        }

        // animate RGB
        function animateRGB() {
            TweenMax.to(theRGB, 4, config.rotate);
        }

        rotateSun();
        moveCloud();
        animateRGB();
    }
};

$(document).ready(animationsZone0.init);
